import { HttpStatusCode } from "axios";
import { ApiRequest } from "../../Handlers/ApiReqest";
import { TraineeTransaction } from "../../Models/Marketer";
import { InterActive } from "../../utilities/ViewModelStructure";
import { Notify } from "../../Handlers/Notifications";

export class TraineeTransactionsTableVM extends InterActive{
    private id:string = ''
    private list:TraineeTransaction[] = []
    private status?:string
    private from?:string
    private to?:string
    private search?:string

    public get List():TraineeTransaction[] { return this.list }
    public get Status():string|undefined { return this.status } 
    public get From():string|undefined  { return this.from }
    public get To( ):string |undefined { return this.to }
    public get Search():string |undefined  { return this.search  }


    public set Status(value:string|undefined) {this.status = value; this.update() } 
    public set From(value:string|undefined)  {this.from = value; this.update() }
    public set To(value:string |undefined ) {this.to = value; this.update() }
    public set Search(value:string |undefined ) {this.search = value; this.update() }

    constructor(id:string){
        super()
        this.id = id
    }

    public getData(){
        this.loading(
            async()=>{
                this.getList()
            }
        )
    }

    public async getList(){
        try{
            const response = await ApiRequest.marketerTransactionsList(this.id, this.status , this.from , this.to , this.search)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(response.data.status){
                        this.list = response.data.data
                        this.update()
                    }else Notify({type:'danger' , title:'مشكلة' , body:response.data.messege})
                }else Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
            }
        }catch{
            Notify({type:'danger' , title:'فشل العملية' , body:'مشكلة غير معروفة ... برجاء مراجعة الاتصال بالانترنت و اعادة المحاولة'})
        }
    }
}